import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface DrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** default "right" (gaveta lateral); "bottom" para a folha "Mais" da TabBar. */
  side?: "right" | "bottom";
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * Gaveta lateral/folha sobre Radix Dialog. Monta em PORTAL NA RAIZ (o padrao
 * de Radix ja usa document.body), cobrindo o app inteiro — menu incluido —
 * como o handoff exige. Escolher um item dentro fecha a gaveta: quem chama
 * `onOpenChange(false)` no clique do item.
 */
export function Drawer({ open, onOpenChange, side = "right", title, children, footer }: DrawerProps): JSX.Element {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="scrim scrim--right" />
        <DialogPrimitive.Content
          className={cn(
            "drawer",
            side === "bottom" && "drawer--bottom",
          )}
          style={
            // Content e Overlay sao IRMAOS dentro do Portal do Radix, nao
            // pai/filho — a gaveta nao herda posicao nenhuma do scrim.
            // Cada lado se posiciona sozinho, sempre fixed contra o
            // viewport (achado real da onda W2: sem isto a gaveta nascia
            // sem `position`, fora do lugar).
            side === "bottom"
              ? {
                  position: "fixed",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  top: "auto",
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "85vh",
                  borderRadius: "1rem 1rem 0 0",
                }
              : { position: "fixed", top: 0, right: 0, height: "100%" }
          }
          aria-label={title}
        >
          <div className="drawer__head">
            <span className="row__title grow">{title}</span>
            <DialogPrimitive.Close className="btn btn--icon btn--ghost" aria-label="Fechar">
              <X className="icon" aria-hidden />
            </DialogPrimitive.Close>
          </div>
          <div className="drawer__body">{children}</div>
          {footer ? <div className="drawer__foot">{footer}</div> : null}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
